/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause': {
    width: 22,
    height: 32,
    viewBox: '0 0 22 32',
    data: '<path pid="0" d="M8 32a.947.947 0 00.719-.297A.988.988 0 009 31V1a.988.988 0 00-.281-.703A.947.947 0 008 0H1a.961.961 0 00-.703.297A.961.961 0 000 1v30c0 .27.099.505.297.703A.961.961 0 001 32h7zm13 0c.27 0 .505-.099.703-.297A.961.961 0 0022 31V1a.961.961 0 00-.297-.703A.961.961 0 0021 0h-6.969a.961.961 0 00-.703.297.961.961 0 00-.297.703v30c0 .27.1.505.297.703a.961.961 0 00.703.297H21zM7 30H2V2h5v28zm13 0h-4.969V2H20v28z" _fill="#000" fill-rule="nonzero"/>'
  }
})
